module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/certificazioneISO/certificazioneISO.component.scss
// module id = ./src/app/certificazioneISO/certificazioneISO.component.scss
// module chunks = main